import { VariableValue } from '@components/Variables/types'

import { AutocompleteOption, FormCommand } from '@types'

import { getVariablesHint } from './getVariablesHint'

export const getObjectXTotalsRowScriptHint = (data: {
  objectX?: AutocompleteOption
  objectY?: AutocompleteOption
  variables: VariableValue[]
  commands?: FormCommand[]
}) => {
  const { objectX, objectY, variables, commands } = data

  return JSON.stringify(
    {
      srcObj: {
        row: {
          yElement: objectY ? objectY.label : 'ObjectY',
          id: 'string',
          groupId: 'string',
          '[key: string // Column key]': `${objectX ? objectX.label : 'ObjectX'}[]`,
          variables: getVariablesHint(variables),
        },
        cellValue: commands?.length
          ? commands.reduce(
              (acc, _, currentIndex) => ({
                ...acc,
                [`commandData${currentIndex + 1}`]: 'any',
              }),
              {}
            )
          : '',
        columnKey: 'string',
      },
    },
    null,
    '\t'
  )
}
